import { memo, useMemo } from 'react';
import type { SnackbarCloseReason } from '@mui/material/Snackbar';
import {
  SnacksSnackbar,
  SnacksSnackbarCloseIcon,
  SnacksSnackbarContentText,
  SnacksSnackbarInnerWrapper,
  SnacksSnackbarOuterWrapper,
  SnacksSnackbarTitleText,
} from '@/features/snacks/Snacks.styles';
import { ConditionGuard } from '@/components/guards/ConditionGuard/ConditionGuard';
import RandomService from '@/services/RandomService/RandomService';
import SnacksService from '@/services/SnackService/SnackService';
import { useSelector } from '@/store/hooks';

export const Snacks = memo(() => {
  const snacks = useSelector(SnacksService.selectAll());
  const snack = useMemo(() => (snacks.length ? snacks[0] : null), [snacks]);

  const handleClose = (_: unknown, reason?: SnackbarCloseReason) => reason !== 'clickaway' && SnacksService.remove();

  return (
    <>
      {snack && (
        <SnacksSnackbar
          open
          key={RandomService.generateUniqId()}
          anchorOrigin={snack.anchorOrigin ?? { horizontal: 'center', vertical: 'top' }}
          autoHideDuration={snack.timeout}
          onClose={handleClose}>
          <SnacksSnackbarOuterWrapper type={snack.type} data-testid={snack?.testId || `${snack.type}Snack`}>
            {snack?.slots?.left}
            <SnacksSnackbarInnerWrapper>
              <ConditionGuard condition={typeof snack.title === 'string'} fallback={snack?.title}>
                <SnacksSnackbarTitleText type={snack.type} variant="body1Bold">
                  {snack.title}
                </SnacksSnackbarTitleText>
              </ConditionGuard>
              <ConditionGuard condition={typeof snack.content === 'string'} fallback={snack?.content}>
                <SnacksSnackbarContentText type={snack.type} variant="body1">
                  {snack.content}
                </SnacksSnackbarContentText>
              </ConditionGuard>
              {snack?.slots?.bottom}
            </SnacksSnackbarInnerWrapper>
            {snack?.slots?.right}
            <SnacksSnackbarCloseIcon type={snack.type} onClick={handleClose} />
          </SnacksSnackbarOuterWrapper>
        </SnacksSnackbar>
      )}
    </>
  );
});

Snacks.displayName = 'Snacks';
